var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVectorimg2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 76,
    viewBox: "0 0 351 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M339.975 27.6608C335.801 27.6608 332.218 30.3456 330.739 34.118C271.837 38.0263 122.808 37.6524 72.7153 33.4723C72.7153 33.4723 72.7153 33.4723 72.6824 33.4723C70.5131 14.7804 55.196 0.302734 36.5591 0.302734C16.4102 0.302734 0.0742188 17.1934 0.0742188 38.0263C0.0742188 58.8592 16.4102 75.7498 36.5591 75.7498C55.2617 75.7498 70.5788 61.1702 72.7153 42.4443C130.631 38.2982 264.08 38.0602 330.772 42.0025C332.284 45.7409 335.834 48.3917 340.008 48.3917C345.53 48.3917 350.033 43.7358 350.033 38.0263C350.033 32.3168 345.563 27.6608 340.008 27.6608H339.975Z",
    fill: "#63262B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorimg2);
export default __webpack_public_path__ + "static/media/Vectorimg2.4c48459d898b4cbb701e8dba81c1c082.svg";
export { ForwardRef as ReactComponent };